import { useTranslation } from "react-i18next";
import { GetPsParams } from "../../../../api/model";
import { useGetPs } from "../../../../api/pss/pss";
import { useDefaultOptions } from "../../../../hooks/api";
import ErrorComponent from "../../../atoms/ErrorComponent";
import WaitComponent from "../../../atoms/WaitComponent";
import PsDetails, { PsDetailsPsGetterCommonProps } from "./PsDetails";

interface Props extends PsDetailsPsGetterCommonProps {
  /** 旧バージョンの PS バージョン ID。 */
  olderPsVersionId: number;
  /** 新バージョンの PS バージョン ID。 */
  newerPsVersionId: number;
}

/** PS を比較用に 2 つ取得するコンポーネント。PsDetails のラッパー。 */
function PsDiffGetter(
  {
    olderPsVersionId,
    newerPsVersionId,
    ...props
  }: Props
) {
  // i18n 用。
  const {
    // t,
    i18n,
  } = useTranslation();

  const defaultOptions = useDefaultOptions(i18n.language);

  /** PS 取得 API 呼び出し。 */
  const getOlderPsResponse = useGetPs(
    olderPsVersionId,
    { edit_flag: 0 } as unknown as GetPsParams,
    defaultOptions
  );

  /** PS 取得 API 呼び出し。 */
  const getNewerPsResponse = useGetPs(
    newerPsVersionId,
    { edit_flag: 0 } as unknown as GetPsParams,
    defaultOptions
  );

  if (
    (getOlderPsResponse.isLoading)
    ||
    (getNewerPsResponse.isLoading)
  ) {
    return (
      <div className="browsefr">
        <WaitComponent />
      </div>
    );
  }

  if (olderPsVersionId !== -1 && (getOlderPsResponse.isError || !getOlderPsResponse.data || !getOlderPsResponse.data.data)) {
    return (
      <div className="browsefr">
        <ErrorComponent error={getOlderPsResponse.error} />
      </div>
    );
  }

  if (newerPsVersionId !== -1 && (getNewerPsResponse.isError || !getNewerPsResponse.data || !getNewerPsResponse.data.data)) {
    return (
      <div className="browsefr">
        <ErrorComponent error={getNewerPsResponse.error} />
      </div>
    );
  }

  return (
    <PsDetails
      ps={{ ...(getNewerPsResponse.data?.data !== undefined ? getNewerPsResponse.data?.data : getOlderPsResponse.data?.data) }}
      olderPs={(getOlderPsResponse.data?.data !== undefined ? { ...getOlderPsResponse.data?.data } : undefined)}
      // eslint-disable-next-line no-nested-ternary
      diffMode={olderPsVersionId === -1 ? 'Add' : (newerPsVersionId === -1 ? 'Delete' : 'Diff')}
      {...props}
    />
  );
}

export default PsDiffGetter;